module.exports = __webpack_public_path__ + "assets/img/folderIcon.9474a527.png";